import { update } from '@thoughtspot/js-util';
import _ from 'lodash';
import { LegendPositionOptions } from '../types/prism';
const getDefaultConfig = () => {
    const defaultConfig = {
        allowLegendWithMultipleY: false,
        radialEnabled: false,
        categoryAxisEnabled: false,
        doNotShowLegend: false,
        colorAxisColumn: undefined,
        enableLegendSelector: true,
        attributesOnYAxis: false,
        noMeasuresOnYAxis: false,
        noMeasuresOnXAxis: true,
        isMultiColorSeries: false,
        useAlphaColors: false,
        useRainbowColors: false,
        useDefaultMinTick: false,
        hasStackedPointsForMultiSeries: false,
        dataLabelsEnabledByDefault: false,
        dataLabelsAlwaysEnabled: false,
        detailedLabelsEnabledByDefault: false,
        StackLabelsEnabledByDefault: false,
        dataLabelFormatter: undefined,
        getMinTickIntervalForXAxis: undefined,
        arbitraryOption: {},
        highThresholdGrouping: false,
        batchSize: '',
        displayYValuesWithLegendSeries: false,
        shouldBringSelectedSeriesToFront: true,
        cardinalityIndexStartsFromZero: false,
        showHighchartTitle: true,
        allowedConfigurations: {
            conditionalFormatEditorParams: {
                isPlotAsBand: true,
                isFont: false,
                isBackgroundColorPickerAvailable: true,
                isConditionalFormattingAllowedOnAttributeColumn: false,
                isConditionalFormattingAllowedOnRadialColumn: false,
            },
            allowAxisCustomization: true,
            geoProjectionType: false,
            showYAxisAsPercent: false,
            zoomPanStateToggle: false,
            showDataLabels: true,
            showStackLabels: false,
            showDetailedLabels: false,
            showAxes: true,
            showRoundedNumbers: false,
            showColorAxis: false,
            xAxisRange: false,
            yAxisRange: false,
            regressionLine: false,
            transposeXY: false,
            allowColorChange: true,
            supportColumnLevelColorChange: true,
            configureColorForXAttrs: false,
            configureColorForYAttrs: true,
            configureColorForRadialAttrs: false,
            markersEnabled: false,
            gradientEnabled: false,
            advanced: {
                display: {
                    overlayHeatMap: false,
                    summaries: false,
                    pivotSummaries: false,
                    pivotSummariesAlignment: false,
                    summaryMode: false,
                    treeLayout: false,
                    showDataFieldArea: false,
                    showLegendPosition: LegendPositionOptions.RightLegend,
                    zoomPanStateToggle: false,
                    useCustomColorSelector: false,
                    responsiveLayout: false,
                    markersEnabled: false,
                    regressionLine: false,
                    gridLines: true,
                    showAllLabels: true,
                    showMaxDataPoints: true,
                    chartSpecific: {
                        customProps: undefined,
                    },
                    handleMissingValues: false,
                    tooltipCustomization: true,
                    showNullAsZero: false,
                },
            },
            excludeNullValues: false,
            gridLines: true,
            gridLineConfig: {
                xGridlineEnabled: false,
                yGridlineEnabled: false,
            },
            showYAxisLinkingOption: true,
            shouldOnlyContainOneYAxis: false,
            optionalXAxisColumns: false,
            useCustomColorSelector: false,
            renameAxis: true,
            repositionAxis: true,
            conditionalFormatting: true,
            allowEnhancedConditionalFormatting: true,
            strokeWidth: 3,
            isSummaryModeAllowed: false,
            onlyTimeSeriesOnXAxis: false,
            allowMultipleColumnsOnYAxis: true,
            allowAttributesInPivotData: false,
            disableSortForAttributeColumns: false,
            allowChartCustomisation: true,
            allowNumberFormatting: true,
            allowSortFormatOption: true,
            measureNameValueColumns: {
                enableMeasureNameColumn: false,
                enableMeasureValueColumn: false,
                measureNameColumnAlias: 'Measure Name',
                measureValueColumnAlias: 'Measure Value',
            },
        },
        incompleteZone: {
            disabled: false,
            getIncompleteColor: undefined,
            getIncompleteThreshold: undefined,
        },
        highcharts: {},
        plotsCumulativeMeasure: false,
        isSummaryEnabledByDefault: false,
        minPointLengthSupported: false,
    };
    return defaultConfig;
};
export class ChartConfigOptions {
    constructor(options = {}) {
        options = options || {};
        const defaultConfig = getDefaultConfig();
        defaultConfig.axesAlias = {
            xAxis: 'chart.chartEditor.chartAxisConfigurator.X_AXIS',
            yAxis: 'chart.chartEditor.chartAxisConfigurator.Y_AXIS',
            radial: 'chart.chartEditor.chartAxisConfigurator.RADIAL',
            legend: 'chart.chartEditor.chartAxisConfigurator.COLOR_AXIS',
            category: 'chart.chartEditor.chartAxisConfigurator.SLICE',
        };
        _.merge(this, defaultConfig, true);
        update(this, options, true, false);
        this.highcharts = {
            ...defaultConfig.highcharts,
            ...options.highcharts,
        };
    }
}
//# sourceMappingURL=chart-config-options.js.map